import { render, staticRenderFns } from "./TarjetaPedido.vue?vue&type=template&id=252bd832"
import script from "./TarjetaPedido.vue?vue&type=script&lang=js"
export * from "./TarjetaPedido.vue?vue&type=script&lang=js"
import style0 from "./TarjetaPedido.vue?vue&type=style&index=0&id=252bd832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports